import { useEffect, useRef } from "react";

import testIds from "constants/testIds";
import { PackingListProvider, usePackingList } from "@RequestFormV2/sections/PackingList/context";
import { useApplyDefaultCommodityCurrency } from "@RequestFormV2/sections/PackingList/hooks/useApplyDefaultCommodityCurrency";
import useShowContainersSection from "@RequestFormV2/sections/PackingList/hooks/useShowContainersSection";
import PackingListHeader from "@RequestFormV2/sections/PackingList/components/PackingListHeader";
import ContainersSection from "@RequestFormV2/sections/PackingList/components/ContainersSection";
import HandlingUnitsSection from "@RequestFormV2/sections/PackingList/components/HandlingUnitsSection";
import CommoditiesSection from "@RequestFormV2/sections/PackingList/components/CommoditiesSection";
import "./PackingList.scss";

function PackingListContent() {
  const showContainers = useShowContainersSection();
  const { ensureInitialRows, defaultCurrency } = usePackingList();
  const hasEnsuredInitialRowsRef = useRef(false);

  useEffect(() => {
    if (hasEnsuredInitialRowsRef.current) return;
    ensureInitialRows();
    hasEnsuredInitialRowsRef.current = true;
  }, [ensureInitialRows]);

  useApplyDefaultCommodityCurrency(defaultCurrency);

  return (
    <div className="rfv2-packing-list" data-testid={testIds.REQUEST_FORM_PACKING_LIST_SECTION}>
      <PackingListHeader />
      <HandlingUnitsSection />
      {showContainers && <ContainersSection />}
      <CommoditiesSection />
    </div>
  );
}

export default function PackingList() {
  return (
    <PackingListProvider>
      <PackingListContent />
    </PackingListProvider>
  );
}
